import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import QuickMenu from "@/components/feature/QuickMenu";
import { useRevealOnScroll } from "@/hooks/useReveal";
import Hero from "./components/Hero";
import About from "./components/About";
import Schedule from "./components/Schedule";
import Programs from "./components/Programs";
import Lineup from "./components/Lineup";
import Gallery from "./components/Gallery";
import Location from "./components/Location";
import ApplySection from "./components/ApplySection";

const marqueeItems = [
  "제27회 입장거봉포도축제",
  "2026. 09. 20 ~ 09. 21",
  "입장초등학교 운동장",
  "거봉포도 수확체험 사전신청",
  "개막 축하공연 · 거봉가요제",
  "관람 무료",
];

function MarqueeBand() {
  return (
    <div className="w-full overflow-hidden bg-gradient-animate py-3">
      <div className="flex w-max animate-marquee">
        {[...marqueeItems, ...marqueeItems].map((text, i) => (
          <span
            key={`${text}-${i}`}
            className="flex items-center gap-3 px-6 text-xs md:text-sm text-white whitespace-nowrap"
          >
            <span className="h-1.5 w-1.5 rounded-full bg-white/70"></span>
            {text}
          </span>
        ))}
      </div>
    </div>
  );
}

export default function Home() {
  const location = useLocation();
  useRevealOnScroll();

  useEffect(() => {
    if (!location.hash) return undefined;
    const id = location.hash.replace("#", "");
    const timer = setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 140);
    return () => clearTimeout(timer);
  }, [location.hash]);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <MarqueeBand />
        <About />
        <Schedule />
        <Programs />
        <Lineup />
        <Gallery />
        <Location />
        <ApplySection />
      </main>
      <Footer />
      <QuickMenu />
      <div className="h-20 lg:hidden"></div>
    </div>
  );
}